import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { shouldUseHashRouting } from '@app/utils/routing-utils';

/**
 * Guest Application Routing Module
 *
 * Defines routes available to unauthenticated guest users.
 * Currently supports:
 * - Meeting join routes for guest access
 *
 * Note: No AuthGuard is applied to any of these routes.
 * All routes are publicly accessible without authentication.
 */
const routes: Routes = [
  {
    path: 'meeting/:meetingId/join',
    loadChildren: () => import('./guest-meetings/guest-meetings.module').then((m) => m.GuestMeetingsModule),
    // No canActivate guard - public access for guests
  },
  {
    path: '',
    redirectTo: '/meeting//join', // Will show error for missing meeting ID
    pathMatch: 'full',
  },
  {
    path: '**',
    // For any other route, redirect to the meeting join page
    // This prevents guests from accessing authenticated routes
    redirectTo: '/meeting//join',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: shouldUseHashRouting() })],
  exports: [RouterModule],
})
export class GuestAppRoutingModule {}
